import React from 'react';
import Car from '../../image/icons/map/tripsDetails/CarIcon';
import Train from '../../image/icons/map/tripsDetails/TrainIcon';
import Tram from '../../image/icons/map/tripsDetails/TramIcon';
import Bus from '../../image/icons/map/tripsDetails/BusIcon';
import Walk from '../../image/icons/map/tripsDetails/WalkingIcon';
import Bicycle from '../../image/icons/map/tripsDetails/BicycleIcon';
import HeLeman from '../../image/icons/map/tripsDetails/HeLemanIcon';
import Donkey from '../../image/icons/map/tripsDetails/RentBikeIcon';
import ArrivalPoint from '../../image/icons/map/tripsDetails/DestinationIcon';
import BlaBlaDaily from '../../image/icons/map/tripsDetails/BlaBlaDaily';
import { type TravelProgressProps } from '../../types/TripPlanner';
import { type SVGComponentProps } from '../../types/Svgs';
import { formatDuration } from '../../tools/TimeRelated';
import MyOwnCarIcon from '../../image/icons/trips/MyOwnCarIcon.svg';

const colorMap = {
  mycar: 'bg-gray-my-car bg-opacity-25',
  car: 'bg-red-car bg-opacity-25',
  train: 'bg-green-train-tram bg-opacity-25',
  subway: 'bg-green-train-tram bg-opacity-25',
  rail: 'bg-green-train-tram bg-opacity-25',
  tram: 'bg-green-train-tram bg-opacity-25',
  bus: 'bg-brown-bus bg-opacity-25',
  coach: 'bg-brown-bus bg-opacity-25',
  bicycle: 'bg-green-walk-bicycle bg-opacity-25',
  walk: 'bg-green-walk-bicycle bg-opacity-25',
  arrivalPoint: 'bg-gray-200 bg-opacity-25',
  rentBike: 'bg-green-walk-bicycle bg-opacity-25',
  blabladaily: 'bg-brown-bus bg-opacity-25',
  heLeman: 'bg-red-car bg-opacity-25'
};

const chooseSize = (distance: number, totalDistance: number, itineraries: number, isMyCar: boolean | undefined) => {
  const percent: number = (distance / totalDistance) * (100 - itineraries * 10) + 30;
  return { width: (isMyCar ?? false) ? '100%' : `${percent}%` };
};

const SwitchIcon: React.FC<SVGComponentProps> = ({ mode, primaryColor, secondaryColor }) => {
  switch (mode) {
    case 'mycar':
      return <img src={MyOwnCarIcon} />;
    case 'car':
      return <Car primaryColor={primaryColor} secondaryColor={secondaryColor} />;
    case 'train':
      return <Train primaryColor={primaryColor} secondaryColor={secondaryColor} />;
    case 'rail':
      return <Train primaryColor={primaryColor} secondaryColor={secondaryColor} />;
    case 'tram':
      return <Tram primaryColor={primaryColor} secondaryColor={secondaryColor} />;
    case 'subway':
      return <Tram primaryColor={primaryColor} secondaryColor={secondaryColor} />;
    case 'bus':
    case 'coach':
      return <Bus primaryColor={primaryColor} secondaryColor={secondaryColor} />;
    case 'walk':
      return <Walk primaryColor={primaryColor} secondaryColor={secondaryColor} />;
    case 'bicycle':
      return <Bicycle primaryColor={primaryColor} secondaryColor={secondaryColor} />;
    case 'arrivalPoint':
      return <ArrivalPoint primaryColor={primaryColor} secondaryColor={secondaryColor} />;
    case 'rentBike':
      return <Donkey primaryColor={primaryColor} secondaryColor={secondaryColor} />;
    case 'blabladaily':
      return <BlaBlaDaily primaryColor={primaryColor} secondaryColor={secondaryColor} />;
    case 'heLeman':
      return <HeLeman primaryColor={primaryColor} secondaryColor={secondaryColor} />;
    default:
      return null;
  }
};

const TravelProgress: React.FC<TravelProgressProps> = ({ legs, isMyCar }) => {
  // Calculate the total distance
  const filterItineraries = legs;
  let totalDistance = filterItineraries.reduce((sum, itinerary) => sum + itinerary.distance, 0);
  const countItineraries = filterItineraries.length;

  return (
    <div id="TravelProgress" className="flex flex-row items-center overflow-y-hidden overflow-x-auto" style={{ padding: '0px 0px 8px 0px' }}>
      {filterItineraries.map((segment, index) => {
        if (segment.mode === 'walk' && segment.duration < 240) {
          totalDistance -= segment.distance;
          return null;
        }
        return (
          <div
            key={`${segment.mode}-${index}`}
            className="flex items-center relative"
            style={chooseSize(segment.distance, totalDistance, countItineraries, isMyCar)}
          >
            <div className="relative">
              <SwitchIcon mode={segment.mode} />
              {segment.mode !== 'walk' &&
                segment.mode !== 'bicycle' &&
                segment.mode !== 'rentBike' &&
                segment.mode !== 'blabladaily' &&
                segment.mode !== 'heLeman' &&
                segment.from?.stop?.id != null &&
                segment.from?.stop?.id !== undefined && (
                  <p
                    className="justify-center flex items-center font-bold bg-ionic-primary text-white absolute -bottom-2 -right-3 p-1 rounded-md h-4 border border-white"
                    style={{
                      // fontSize: segment.routeShortName != null ? (segment.routeShortName.length > 3 ? '6px' : '10px') : '10px',
                      fontSize: '10px'
                    }}
                  >
                    {segment.routeShortName?.slice(0, 5)}
                  </p>
              )}
            </div>
            <div className={`-z-10 h-7 ${colorMap[segment.mode]} flex justify-center items-center -ml-2 -mr-2 w-full`}>
              {isMyCar === true ? <span className="text-[14px] text-ionic-main font-bold">Je prends ma voiture</span> : ''}
              {segment.from?.stop?.id != null &&
              segment.from?.stop?.id !== undefined &&
              segment.mode !== 'walk' &&
              segment.mode !== 'bicycle' &&
              segment.mode !== 'rentBike' ? (
                <span className="text-[12px] text-black">{formatDuration(segment.duration)}</span>
                  ) : (
                    ''
                  )}
              {segment.mode === 'walk' || segment.mode === 'bicycle' || segment.mode === 'rentBike' || segment.mode === 'blabladaily' ? (
                <span className="text-[12px] text-black">{formatDuration(segment.duration)}</span>
              ) : (
                ''
              )}
            </div>
          </div>
        );
      })}
      <SwitchIcon mode={'arrivalPoint'} primaryColor={isMyCar === true ? '#11D39C' : '#ff4500'} secondaryColor="#ffd700" />
    </div>
  );
};

export default TravelProgress;
